import './App.css';
import { Router } from './modules/routes';
import Header from './modules/header/header';
import { HashRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";



function App() {
  return (
    <HelmetProvider>
      <HashRouter>
        <Header />
        <div style={{ marginTop: "64px", height: "calc(100vh - 64px)", overflow: "auto" }}>
          <Router />
        </div>
      </HashRouter>
    </HelmetProvider>
  );
}

export default App;
